<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="车辆信息维护"
    :visible.sync="dialogFormVisible"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="运输司机姓名" prop="driverName">
        <el-input v-model.trim="formData.driverName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="运输司机电话" prop="driverTel">
        <el-input v-model.trim="formData.driverTel" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="车牌号" prop="vehicleLicenseNo">
        <el-input
          v-model.trim="formData.vehicleLicenseNo"
          placeholder="请输入车牌号"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { carNumReg, phoneReg } from "@/hooks/regex";
import { operateCarInfo } from "@/api/oldForNew";

export default {
  components: {},
  data() {
    return {
      id: "",
      dialogFormVisible: false,
      type: "add",
      formData: {
        orderNo: "",
        operateType: 2,
        driverName: "",
        driverTel: "",
        vehicleLicenseNo: ""
      },
      rules: {
        driverName: [
          { required: true, message: "请输入司机姓名", trigger: "blur" }
        ],
        driverTel: [
          { required: true, message: "请输入司机电话", trigger: "blur" },
          { pattern: phoneReg, trigger: "blur", message: "请输入正确的手机号" }
        ],
        vehicleLicenseNo: [
          { required: true, message: "请输入车牌号码", trigger: "blur" },
          {
            pattern: carNumReg,
            trigger: "blur",
            message: "请输入正确的车牌号码"
          }
        ]
      },
      btnLoading: false
    };
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    openDialog(rowData) {
      this.formData.orderNo = rowData.orderNo;
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存和编辑数据接口
    async save() {
      let { statusCode, message } = await operateCarInfo(this.formData);
      if (statusCode == 200) {
        this.$message.success("保存成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/carDialog.vue